export const QUIZ_FLOW_SCREEN_NAMES = {
  dark: 'DarkScreen',
  question: 'QuestionScreen',
  lets_create_plan: 'CreatePlanScreen',
  creating_plan: 'CreatingPlanScreen',
  reviews: 'ReviewsScreen',
  plan_effect: 'PlanEffectScreen',
  world_trust: 'WorldWideTrustScreen',
  world_trust_v2: 'WorldWideTrustScreen_v2',
  kegel_helps: 'HelpImproveScreen',
  best_thing: 'BestThingScreen',
  final_adjustment: 'FinalAdjustmentScreen',
  analyzing_answers: 'AnalyzingAnswers'
}

export const QUIZ_LAYOUTS = {
  dark: 'DarkLayout',
  light: 'LightLayout',
}
export const TRACK_IDS = {
  erection: 1,
  ejaculation: 2,
  welness: 3
}

export const TRACK_LABELS = {
  v2: {
    erection: 'Improve Erectile Function',
    ejaculation: 'Improve Ejaculation Control',
    welness: 'Maximize Intimate Wellness<br>(Improve both of the above)'
  },
  v3: {
    erection: 'Improve Erectile Function',
    ejaculation: 'Improve Ejaculation Control',
    welness: 'Maximize Sexual Wellness<br>(Improve both of the above)'
  },
  v5: {
    erection: 'Improve Erectile Function',
    ejaculation: 'Improve Ejaculation Control',
    welness: 'Maximize Sexual Wellness<br>(Improve both of the above)'
  }
}
